import apiInstance from "../api";
import endPoints from "../endpoints";

export const getMappingProfiles = () => {
  return apiInstance().get(`${endPoints.mapper.getMappingProfiles}`);
};
export const getAllProfiles = () => {
  return apiInstance().get(`${endPoints.mapper.getProfiles}`);
};
export const getInputProfiles = () => {
  return apiInstance().get(`${endPoints.mapper.getInputProfiles}`);
};
export const getOutputProfiles = () => {
  return apiInstance().get(`${endPoints.mapper.getOutputProfiles}`);
};

export const getOutputProfileName = () => {
  return apiInstance().get(`${endPoints.mapper.getOutputProfileName}`);
};

export const getProfileData = (id) => {
  return apiInstance().get(`${endPoints.mapper.getProfileData}/${id}`);
};
export const verifyMapService = (id) => {
  return apiInstance().get(`${endPoints.mapper.verifyMapService}/${id}`);
};

export const onProfileCreate = (payload) => {
  return apiInstance().post(endPoints.mapper.saveOnProfileCreate, payload, {
    headers: { "content-type": "multipart/form-data" },
  });
};

export const tempMappingOnProfileCreate = (payload) => {
  return apiInstance().post(
    endPoints.mapper.SaveOnTempMappingProfileCreate,
    payload,
    {
      headers: { "content-type": "multipart/form-data" },
    }
  );
};

export const deleteOutputProfile = (payload) => {
  return apiInstance().delete(
    `${endPoints.mapper.deleteOutputProfile}/${payload}`
  );
};

export const saveProfileFromYaml = (payload) => {
  return apiInstance().post(endPoints.mapper.saveProfileFromYaml, payload, {
    headers: { "content-type": "multipart/form-data" },
  });
};

export const saveBasicInformation = (payload) => {
  return apiInstance().post(
    `${endPoints.mapper.SaveBasicInformation}`,
    payload
  );
};

export const fixedWidthOutputMappingSave = (payload) => {
  return apiInstance().post(
    `${endPoints.mapper.fixedWidthOutputMappingSave}`,
    payload
  );
};

export const onFixedLengthFileCreate = (payload) => {
  return apiInstance().post(
    `${endPoints.mapper.onFixedLengthFileCreate}`,
    payload
  );
};

export const cloneProfile = (id, name) => {
  return apiInstance().get(`${endPoints.mapper.cloneProfile}/${id}/${name}`);
};

export const cloneOutputProfile = (id, name) => {
  return apiInstance().get(
    `${endPoints.mapper.cloneOutputProfile}/${id}/${name}`
  );
};

export const downloadSampleFixedWidthFile = (id) => {
  return apiInstance().get(
    `${endPoints.mapper.downloadSampleFixedWidthFile}/${id}`
  );
};

export const validateOutputProfile = (name) => {
  return apiInstance().get(`${endPoints.mapper.validateOutputProfile}/${name}`);
};

export const getActivePlans = (payload) => {
  return apiInstance().post(`${endPoints.mapper.getActivePlans}`, payload);
};

export const checkProfileNameExists = (id, profileName) => {
  return apiInstance().get(
    `${endPoints.mapper.checkProfileNameExists}/${id}/${profileName}`
  );
};

export const searchProfiles = (payload) => {
  return apiInstance().post(`${endPoints.mapper.searchProfiles}`, payload);
};

export const onUpdateStatus = (payload) => {
  return apiInstance().post(`${endPoints.mapper.UpdateStatus}`, payload);
};

export const onMappingChange = (payload) => {
  return apiInstance().post(`${endPoints.mapper.mappingChange}`, payload);
};

export const onProfileNameChange = (payload) => {
  return apiInstance().post(`${endPoints.mapper.profileNameChange}`, payload);
};

export const onAggregateSave = (payload) => {
  return apiInstance().post(`${endPoints.mapper.onAggregateSave}`, payload);
};

export const onSchedulerSave = (payload) => {
  return apiInstance().post(`${endPoints.mapper.onSchedulerSave}`, payload);
};

export const onFilterSave = (payload) => {
  return apiInstance().post(`${endPoints.mapper.onFilterSave}`, payload);
};

export const onUpdatePlans = (payload) => {
  return apiInstance().post(`${endPoints.mapper.updatePlans}`, payload);
};

export const onUpdateInputPlanGroups = (payload) => {
  return apiInstance().post(
    `${endPoints.mapper.updateInputPlanGroups}`,
    payload
  );
};

export const deleteInputPlanGroupOutputById = (planGroupId) => {
  return apiInstance().delete(
    `${endPoints.mapper.deleteInputPlanGroupOutputById}/${planGroupId}`
  );
};

export const onSaveTarget = (payload) => {
  return apiInstance().post(`${endPoints.mapper.saveTargetType}`, payload);
};

export const deleteMappingProfile = (id) => {
  return apiInstance().delete(`${endPoints.mapper.deleteMappingProfile}/${id}`);
};
export const downloadProfileAsYaml = (id, name) => {
  return apiInstance().get(
    `${endPoints.mapper.downloadProfileAsYaml}/${id}/${name}`
  );
};

//output mapper
export const onSaveOutputTarget = (payload) => {
  return apiInstance().post(`${endPoints.mapper.saveOutputTarget}`, payload);
};

export const onOutputFilterSave = (payload) => {
  return apiInstance().post(`${endPoints.mapper.onOutputFilterSave}`, payload);
};

export const onSaveMapAndTransformOutput = (payload) => {
  return apiInstance().post(
    `${endPoints.mapper.saveMapAndTransformOutput}`,
    payload
  );
};

export const deletePlanGroupInOutput = (planGroupId) => {
  return apiInstance().delete(
    `${endPoints.mapper.DeletePlanGroupOutputById}/${planGroupId}`
  );
};

export const onUpdateOutputPlans = (payload) => {
  return apiInstance().post(`${endPoints.mapper.updateOutputPlans}`, payload);
};

export const updatePlanGroups = (payload) => {
  return apiInstance().post(`${endPoints.mapper.updatePlanGroups}`, payload);
};

export const outputSaveBasicInformation = (payload) => {
  return apiInstance().post(
    `${endPoints.mapper.outputSaveBasicInformation}`,
    payload
  );
};
export const getOutputProfileData = (id) => {
  return apiInstance().get(`${endPoints.mapper.getOutputProfileData}/${id}`);
};

//passthrough
export const passthroughSaveBasicInformation = (payload) => {
  return apiInstance().post(
    `${endPoints.mapper.passthroughSaveBasicInformation}`,
    payload
  );
};

export const savePassthroughMapAndTransform = (payload) => {
  return apiInstance().post(
    `${endPoints.mapper.savePassthroughMapAndTransform}`,
    payload
  );
};

export const getPassthroughProfileData = (id) => {
  return apiInstance().get(
    `${endPoints.mapper.getPassthroughProfileData}/${id}`
  );
};

export const saveOnSourceProfileCreate = (payload) => {
  return apiInstance().post(
    endPoints.mapper.saveOnSourceProfileCreate,
    payload,
    {
      headers: { "content-type": "multipart/form-data" },
    }
  );
};

export const saveOnTargetProfileCreate = (payload) => {
  return apiInstance().post(
    endPoints.mapper.saveOnTargetProfileCreate,
    payload,
    {
      headers: { "content-type": "multipart/form-data" },
    }
  );
};

export const onSavePassthroughTarget = (payload) => {
  return apiInstance().post(
    `${endPoints.mapper.savePassthroughTarget}`,
    payload
  );
};

export const onSavePreview = (payload) => {
  return apiInstance().post(`${endPoints.mapper.savePreview}`, payload);
};

export const onSaveSplit = (payload) => {
  return apiInstance().post(`${endPoints.mapper.saveSplit}`, payload);
};

export const saveValidation = (payload) => {
  return apiInstance().post(`${endPoints.mapper.saveValidation}`, payload);
};

export const getValidationRules = (id) => {
  return apiInstance().get(`${endPoints.mapper.getValidationRules}/${id}`);
};

export const onPassthroughFilterSave = (payload) => {
  return apiInstance().post(
    `${endPoints.mapper.onPassthroughFilterSave}`,
    payload
  );
};

export const onPassthroughAggregateSave = (payload) => {
  return apiInstance().post(
    `${endPoints.mapper.saveOnPassthroughAggregate}`,
    payload
  );
};

export const getTargetDetails = (id) => {
  return apiInstance().get(`${endPoints.mapper.getTargetDetails}/${id}`);
};

export const getTargetModelValues = () => {
  return apiInstance().get(`${endPoints.mapper.getTargetModelValues}`);
};
